import { Component } from '@verndale/core';
import Swiper from 'swiper/js/swiper';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      el: this.el,
      slider: this.el.querySelector('.swiper-container')
    };

    this.breakpoint = window.matchMedia('(min-width: 980px)');
    this.checkBreakpoint();
  }

  addListeners() {
    this.breakpoint.addListener(::this.checkBreakpoint);
  }

  checkBreakpoint() {
    // if larger viewport and multi-row layout needed
    if (this.breakpoint.matches === true) {
      // clean up old instances and inline styles when available
      if (this.swiper) this.swiper.destroy(true, true);
      // or/and do nothing
      return;
      // else if a small viewport and single column layout needed
    } else if (this.breakpoint.matches === false) {
      // fire small viewport version of swiper
      return this.initSlider();
    }
  }

  initSlider() {
    this.swiper = new Swiper(this.dom.slider, {
      slidesPerView: 'auto',
      spaceBetween: 35,
      init: true
    });
  }
}

export default Module;
